import { endOfDay, isToday, startOfDay } from 'date-fns';

export function startedWithin(firstActivityDate: string | null, dateRange: [Date, Date] | null): boolean {
  if (!firstActivityDate) {
    return false;
  }
  if (!dateRange) {
    return true;
  }

  const [from, to] = dateRange;
  const startedOn = new Date(firstActivityDate).getTime();

  return startedOn >= startOfDay(from).getTime() && (isToday(to) || startedOn <= endOfDay(to).getTime());
}
